import { cn } from '@helpers/cn';

import { EnvironmentBadge } from '..';
import { TProps } from '../types/TProps';

export const EnvironmentBadgeDev = ({ className, ...props }: TProps) => (
  <EnvironmentBadge {...props} className={cn('env-badge--dev', className)} />
);
